.component {
  margin: 23px var(--margin) 20px 20px;
  overflow: auto;
  height: 100%;
}

.title {
  margin-bottom: 10px;
  font-size: 26px;
  font-weight: 300;
  color: var(--tealish);
}

.subTitle {
  width: 580px;
  font-size: 14px;
  color: var(--marine);
}

.subTitle a {
  color: var(--tealish);
}

.section {
  margin-top: 28px;
}

.sectionTitle {
  font-size: 16px;
  font-weight: 600;
  color: var(--marine);
  margin-bottom: 10px;
}

/* ─── Platform card ─────────────────────────────────────────── */

.card {
  width: 560px;
  background-color: var(--fully-white);
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin-bottom: 8px;
  overflow: hidden;
}

.cardConnected {
  border-left: 3px solid var(--tealish);
}

.cardSuccess {
  border-left: 3px solid var(--tealish);
  background-color: var(--ice-blue);
}

.cardHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 14px;
  gap: 10px;
}

.platformName {
  flex: 1;
  font-size: 15px;
  font-weight: 500;
  color: var(--marine);
}

.statusConnected {
  font-size: 12px;
  color: var(--tealish);
  font-weight: 600;
}

.statusIdle {
  font-size: 12px;
  color: var(--brown-grey);
}

.setupButton {
  background: none;
  border: 1px solid var(--marine);
  border-radius: 3px;
  color: var(--marine);
  font-size: 12px;
  padding: 4px 10px;
  cursor: pointer;
}

.setupButton:hover {
  background-color: var(--marine);
  color: var(--fully-white);
}

.collapseButton {
  background: none;
  border: none;
  color: var(--brown-grey);
  font-size: 14px;
  cursor: pointer;
  padding: 4px 6px;
}

.docsLink {
  font-size: 12px;
  color: var(--tealish);
  text-decoration: none;
}

.docsLink:hover {
  text-decoration: underline;
}

/* ─── Card body ─────────────────────────────────────────────── */

.cardBody {
  padding: 0 14px 14px 14px;
  border-top: 1px solid var(--pinkish-grey);
}

.steps {
  font-size: 13px;
  color: var(--marine);
  padding-left: 18px;
  margin: 12px 0 10px;
  line-height: 1.7;
}

.commandBlock {
  background-color: var(--light-grey);
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.commandBlock pre {
  flex: 1;
  font-size: 12px;
  color: var(--marine);
  margin: 0;
  white-space: pre-wrap;
  word-break: break-all;
  font-family: monospace;
}

.copyButton {
  background: none;
  border: 1px solid var(--pinkish-grey);
  border-radius: 3px;
  font-size: 11px;
  color: var(--brown-grey);
  padding: 3px 8px;
  cursor: pointer;
  flex-shrink: 0;
}

.copyButton:hover {
  border-color: var(--marine);
  color: var(--marine);
}

.connectButton {
  background-color: var(--marine);
  color: var(--fully-white);
  border: none;
  border-radius: 3px;
  font-size: 13px;
  padding: 8px 16px;
  cursor: pointer;
  margin-top: 4px;
}

.connectButton:hover {
  opacity: 0.85;
}

.cancelButton {
  background: none;
  border: none;
  color: var(--brown-grey);
  font-size: 13px;
  cursor: pointer;
  margin-top: 8px;
  padding: 0;
}

/* ─── Waiting state ─────────────────────────────────────────── */

.waitingRow {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0 6px;
  font-size: 13px;
  color: var(--brown-grey);
}

.waitingSpinner {
  width: 14px;
  height: 14px;
  border: 2px solid var(--pinkish-grey);
  border-top-color: var(--tealish);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.unknownNote {
  font-size: 12px;
  color: var(--brown-grey);
  margin-top: 8px;
}

.loadingText {
  font-size: 13px;
  color: var(--brown-grey);
}
